import React from "react";
import loadingSpinner from "../images/loadingSpinner.svg";

import "./LoadingSpinner.css";
const LoadingSpinner = () => {
  return (
    <div className="loading-spinner-container">
      <img src={loadingSpinner} alt="loading..." className="loading-spinner" />
    </div>
  );
};

export default LoadingSpinner;
